import React, {
    useContext
} from 'react';
import animatedLoader from 'saga-styling/common-styles/theme/assets/images/loader-animated.gif';
import { TranslatorContext } from '@jutro/locale';
import messages from './SgFailedDownloadPayment.messages';

function SgFailedDownloadPayment(props) {
    const {
        showFailedDownloadMsg
    } = props;

    const translator = useContext(TranslatorContext);

    return (
        <>
            {showFailedDownloadMsg && (
                <div className="sgFailedPaymentMessage">
                    <p>{translator(messages.RetrievePreviousPayment)}</p>
                    <div>
                        <img
                            className="loader"
                            alt="Loading..."
                            src={animatedLoader}
                        />
                    </div>
                    <p>{translator(messages.CPARefresh)}</p>
                </div>
            )}
        </>
    );
}
export default SgFailedDownloadPayment;
